import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { usePermissions } from "@poseidon/ui/components";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { columnDefinitions } from "./getColumnDefinition";
import { useApplications } from "../../hooks/useApplications";
import { CreateApplicationFab } from "../../create/CreateApplicationFab";

export default function ListApplications() {
  const { setError } = useErrorMessage();
  const { canWrite } = usePermissions();
  const { applications, loading, error } = useApplications();

  if (error) {
    setError(error);
  }
  if (loading || !applications) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <DataGridContainer>
      <DataGrid
        useSessionStorageForPagination
        id="applications"
        columns={columnDefinitions}
        rows={applications}
        loading={loading}
        doubleClickSlug="applications"
        initialState={{
          sorting: {
            sortModel: [{ field: "applicationNumber", sort: "desc" }],
          },
        }}
      />
      {canWrite && <CreateApplicationFab />}
    </DataGridContainer>
  );
}
